import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Collapse } from 'react-bootstrap'
import Clickable from 'components/clickable'
import ShopItem from './shop-item'
import css from './store-section.scss'

const StoreSection = ({
  label,
  items,
  registryDiscountAvailable,
  storeName,
  openRedirectModal,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [stickyHeight, setStickyHeight] = useState()

  useEffect(() => {
    setStickyHeight(document.getElementById('header').offsetHeight)
  }, [])

  return (
    <div className="mbxl">
      <Clickable
        className={css.storeHeader}
        onClick={() => setIsCollapsed(!isCollapsed)}
        style={{ display: 'block', width: '100%', top: stickyHeight }}
      >
        <div className="flex align-center bbs pvl-md pvm">
          <div className="flex grow">
            <div>
              <span className="h3 text-bold">From {label}</span>{' '}
              <span className="h5 hidden-xs">
                — {items.length} Available Items
              </span>
              <div className="xsmall mtm visible-xs">
                {items.length} Available Items
              </div>
            </div>
          </div>
          <i
            className={classNames(
              { 'rotate-180': isCollapsed },
              'fa fa-chevron-down h7 text-muted'
            )}
          />
        </div>
      </Clickable>
      <Collapse in={!isCollapsed}>
        <div className="animated animate-250ms fadeIn">
          {items.map((item) => {
            return (
              <ShopItem
                key={item.id}
                item={item}
                registryDiscountAvailable={registryDiscountAvailable}
                storeName={storeName}
                openRedirectModal={openRedirectModal}
              />
            )
          })}
        </div>
      </Collapse>
    </div>
  )
}

StoreSection.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  registryDiscountAvailable: PropTypes.bool.isRequired,
  storeName: PropTypes.string.isRequired,
}

export default StoreSection
